<template>
  <li class="reservation-list-item col-12">
    <div class="input-table-shadow">
      <div class="row align-items-center no-gutters">
        <div class="col pl-3">
          <input
            class="reservation-id"
            type="text"
            :value="item.service.code"
            readonly="readonly"
          />
        </div>
        <div class="col pl-3 dark-background">
          <input
            class="reservation-id"
            type="text"
            :value="item.itemsCount"
            readonly="readonly"
          />
        </div>
        <div class="col pl-3 dark-background">
          <input
            class="reservation-id"
            type="text"
            :value="item.service.serviceCategory.name_NL"
            readonly="readonly"
          />
        </div>
        <div class="col pl-3 dark-background">
          <core-money-input
            bold="true"
            :amount="item.sumTotalSalePrice"
            :readonly="true"
          ></core-money-input>
        </div>
        <!-- <div class="col pl-3 dark-background">
          <input
            class="reservation-id"
            type="text"
            :value="item.service.ledgerIdTurnover"
            readonly="readonly"
          />
        </div> -->
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    item: {
      default: () => {},
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/trip-reports/ListItem.vue